import React, { useContext }from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { HrFlexContainer, HrGridContainer, HrTitleContainer, HrTitleH4, Tablet } from '@components/styles/hr-styles';
import { Input } from '@components/form/input';
import styled from 'styled-components';
import { DisplaySettingsContext } from '../../../postulation_form/store/display-settings';

const Container = styled(HrGridContainer)`
  padding: 0 32px;

  @media (max-width: ${Tablet}) {
    grid-template-columns: repeat(1, 1fr);
    padding: 0 16px;
  }
`;

export const Legacy = observer(({ vacancyRequirement, register, formState }) => {
  const [t] = useTranslation();
  const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);

  return (
    <HrFlexContainer flexDirection='column' alignItems='flex-start'>
      <HrTitleContainer>
        <HrTitleH4 fontSizeSetting={fontSizeSetting} color={darkMode ? 'white' : ''} isRequired={vacancyRequirement.legacy === 1}>{t('postulant.legacy.title')}</HrTitleH4>
      </HrTitleContainer>

      <Container>
        <Input
          title={t('postulant.legacy.legacy')}
          placeholder={t('postulant.legacy.placeholder')}
          name='legacy'
          type='text'
          register={register}
          formState={formState}
          validate={{
            required: vacancyRequirement.legacy === 1,
            whiteSpace: true
          }}
          errorPosition='bottom'
        />
      </Container>
    </HrFlexContainer>
  );
});
